module.exports = __webpack_public_path__ + "img/candidates.46b9d5fc.svg";